<template>
  <div class="btn-wrapper" v-show="loaded">
    <button
      class="green"
      type="button"
      :class="{'applied': deadline}"
      :disabled="deadline"
      @click.prevent="clickBtn"
      id="free-ticket-url"
    >
      {{ entryAfter | setButtonLabel(finishFesta, deadline) }}
    </button>
  </div>
</template>

<script>
import { getEventUrl1 } from '@/helpers/utils.js'

export default {
  data: () => ({
    isDisabled: false
  }),
  props: {
    loaded: {
      type: Boolean,
      required: true
    },
    isAuthed: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    // entryBefore () {
    //   return this.$moment().isBefore('2020-10-02 09:59')
    // },
    entryAfter () {
      return this.$moment().isBetween('2020-10-02 18:00', '2020-10-03 09:59')
    },
    finishFesta () {
      return this.$moment().isAfter('2020-10-03 16:20')
    },
    deadline () {
      const now = this.$moment(new Date())
      const deadlineAt1003 = this.$moment('2020-10-03 15:45')
      const at1003 = this.$moment('2020-10-02 00:00:00')
      // 3日の締め切り時間
      if (now.diff(deadlineAt1003) > 0) {
        return true
      }
      // 3日の0時から応募受付開始
      if (now.diff(at1003) > 0) {
        return false
      }
      const deadline = this.$moment('2020-10-02 15:45')
      return deadline.diff(now) < 0
    }
  },
  methods: {
    clickBtn () {
      let attachUrl
      if (this.entryAfter) {
        attachUrl = getEventUrl1('https://l-ma.co.jp/events/5691')
        window.open(attachUrl, '_blank')
        return
      } 
      // if (!this.isAuthed) {
      //   this.$emit('to-login')
      //   return
      // }
      if (this.$moment().isBetween('2020-10-02 10:00', '2020-10-02 15:45')) {
        attachUrl = getEventUrl1('https://ws.formzu.net/dist/S49100349/')
        if (this.$moment().isBetween('2020-10-02 10:00', '2020-10-02 15:45')) {
          window.open(attachUrl, '_blank')
        }
      } else if (this.$moment().isBetween('2020-10-03 09:59', '2020-10-03 15:45')) {
        attachUrl = getEventUrl1('https://ws.formzu.net/dist/S68883495/')
        if (this.$moment().isBetween('2020-10-03 09:59', '2020-10-03 15:45')) {
          window.open(attachUrl, '_blank')
        }
      }
    }
  },
  filters: {
    setButtonLabel (entryAfter, finishFesta, deadline) {
      if (entryAfter) {
        return '無料参加チケットを取得'
      }
      if (finishFesta) {
        return '各コンテンツ配信はアーカイブ視聴できます（一部除く）'
      }
      return 'プレゼントBOX＆抽選会応募はこちら'
    }
  }
}
</script>

<style lang="sass" scoped>
.btn-wrapper
  width: 100%
  max-width: 320px
  margin: 0 auto
  button
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    height: 56px
    color: #fff
    background-color: $green
    border: none
    border-radius: 8px
    padding: 0
    margin: 0 auto
    font-size: 1.6rem
    cursor: pointer
  .applied
    background-color: gray
    padding: 0 25px
</style>
